import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Dots',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M2.0179 7.91667C2.47814 7.91667 2.85124 7.54357 2.85124 7.08333C2.85124 6.6231 2.47814 6.25 2.0179 6.25C1.55767 6.25 1.18457 6.6231 1.18457 7.08333C1.18457 7.54357 1.55767 7.91667 2.0179 7.91667Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("path", {
      d: "M2.0179 13.75C2.47814 13.75 2.85124 13.3769 2.85124 12.9167C2.85124 12.4564 2.47814 12.0833 2.0179 12.0833C1.55767 12.0833 1.18457 12.4564 1.18457 12.9167C1.18457 13.3769 1.55767 13.75 2.0179 13.75Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_3),
    _createElementVNode("path", {
      d: "M7.33919 7.91667C7.79943 7.91667 8.17253 7.54357 8.17253 7.08333C8.17253 6.6231 7.79943 6.25 7.33919 6.25C6.87896 6.25 6.50586 6.6231 6.50586 7.08333C6.50586 7.54357 6.87896 7.91667 7.33919 7.91667Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_4),
    _createElementVNode("path", {
      d: "M7.33919 13.75C7.79943 13.75 8.17253 13.3769 8.17253 12.9167C8.17253 12.4564 7.79943 12.0833 7.33919 12.0833C6.87896 12.0833 6.50586 12.4564 6.50586 12.9167C6.50586 13.3769 6.87896 13.75 7.33919 13.75Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_5),
    _createElementVNode("path", {
      d: "M12.6605 7.91667C13.1207 7.91667 13.4938 7.54357 13.4938 7.08333C13.4938 6.6231 13.1207 6.25 12.6605 6.25C12.2002 6.25 11.8271 6.6231 11.8271 7.08333C11.8271 7.54357 12.2002 7.91667 12.6605 7.91667Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_6),
    _createElementVNode("path", {
      d: "M12.6605 13.75C13.1207 13.75 13.4938 13.3769 13.4938 12.9167C13.4938 12.4564 13.1207 12.0833 12.6605 12.0833C12.2002 12.0833 11.8271 12.4564 11.8271 12.9167C11.8271 13.3769 12.2002 13.75 12.6605 13.75Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_7),
    _createElementVNode("path", {
      d: "M17.9818 7.91667C18.442 7.91667 18.8151 7.54357 18.8151 7.08333C18.8151 6.6231 18.442 6.25 17.9818 6.25C17.5215 6.25 17.1484 6.6231 17.1484 7.08333C17.1484 7.54357 17.5215 7.91667 17.9818 7.91667Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_8),
    _createElementVNode("path", {
      d: "M17.9818 13.75C18.442 13.75 18.8151 13.3769 18.8151 12.9167C18.8151 12.4564 18.442 12.0833 17.9818 12.0833C17.5215 12.0833 17.1484 12.4564 17.1484 12.9167C17.1484 13.3769 17.5215 13.75 17.9818 13.75Z",
      stroke: __props.strokeColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_9)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})